export const productTypes = [
  { label: 'Automovil', value: '1' },
  { label: 'Belleza', value: '2' },
  { label: 'Deportes y Aire Libre', value: '3' },
  { label: 'Electrónicos', value: '4' },
  { label: 'Herramientas y Mejoras del Hogar', value: '5' },
  { label: 'Hogar y Cocina', value: '6' },
  { label: 'Instrumentos Musicales', value: '7' },
  { label: 'Jardín', value: '8' },
  { label: 'Juegos y Juguetes', value: '9' },
  { label: 'Libros', value: '10' },
  { label: 'Oficina y Papelería', value: '11' },
  { label: 'Productos ecológicos', value: '12' },
  { label: 'Ropa, Zapatos y Accesorios', value: '13' },
  { label: 'Salud y Cuidado Personal', value: '14' },
  { label: 'Videojuegos', value: '15' },
];

interface ICompanyExperience {
  value: string;
  label: string;
}

export const companyExperience: ICompanyExperience[] = [
  {
    value: '1',
    label: '1 a 100',
  },
  {
    value: '2',
    label: 'Entre 100 y 4000',
  },
  {
    value: '3',
    label: 'Más de 4000',
  },
];

export const GENERIC_REDUCER = (state: any, payload: any) => {
  if (payload) return { ...state, ...payload };
  else return state;
};
